module.exports = __webpack_public_path__ + "img/17874_S.88ea0b9f.png";